module.exports = __webpack_public_path__ + "media/images/landing/bg/video-poster-mobile-4889328723fe7970d4cc9f695560dbb8.png";